import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Form } from "banafo-design-system";
import "./DatePickerInput.scss";
const DatePickerInput = forwardRef((props, ref) => {
    return (_jsx(Form.Control, Object.assign({}, props, { ref: ref, className: "calendar" })));
});
DatePickerInput.displayName = 'DatePickerInput';
export default DatePickerInput;
